import React, { useMemo } from 'react';
import keyBy from 'lodash/keyBy';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { addPinyinToHtml } from 'shared/utils/pinyin';
import { HtmlWithPinyinContent } from './HtmlWithPinyinContent';
import { spacedPinyinPropType } from 'shared/utils/pinyin/prop-types';

export const HtmlWithPinyin = ({ html, spacedPinyin, className }) => {
  const htmlWithPinyin = useMemo(() => {
    if (isEmpty(spacedPinyin)) {
      return html;
    }

    const pinyinMap = keyBy(spacedPinyin, 'index');
    return addPinyinToHtml({ html, pinyinMap });
  }, [html, spacedPinyin]);

  return <HtmlWithPinyinContent html={htmlWithPinyin} className={className} />;
};

HtmlWithPinyin.propTypes = {
  html: PropTypes.string,
  spacedPinyin: spacedPinyinPropType,
  className: PropTypes.string,
};

HtmlWithPinyin.defaultProps = {
  html: '',
  spacedPinyin: [],
};
